import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const Unauthorized = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const messageCode = searchParams.get('message');
  
  const errorMessage = messageCode === 'no_group' 
    ? "You are not part of any authorized access group. Please contact your administrator."
    : (messageCode || "You are not part of any authorized access group. Please contact your administrator.");

  return (
    <Container maxWidth="sm">
      <Box 
        sx={{ 
          minHeight: '100vh',   
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          alignItems: 'center'      
        }}
      >
        <Paper elevation={3} sx={{ p: 5, textAlign: 'center', borderRadius: 2 }}>
          <ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
          
          <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
            Access Denied
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            {errorMessage}
          </Typography>
          
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => navigate('/')}
          >
            Back to Login
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default Unauthorized;